import { Component, Input } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Partner } from '../../../../../model/partner.model';

@Component({
    selector: 'app-facility',
    templateUrl: './facility.component.html',
    styleUrls: ['./facility.component.scss'],
    imports: [TranslateModule, RouterModule],
})
export class FacilityComponent {
    @Input({ required: true }) partner!: Partner;

    formatPhoneForTel(phone: string) {
        return phone.replace(/\s/g, '');
    }
}
